export default "__VITE_ASSET__d25474cc__"